import React from 'react'

type Props = {
    noPadding?  : boolean

    children?   : any
}

export default function CustomFieldPreview(props: Props) {
    return (
        <div className="details-item">
            <div className="label-details ui5-txt-not-important-tiny">Preview:</div>
            <div className={Classes("cf-preview", "p-l-10", "p-r-10", "flex-r", "fl-ac", "fl-sb", "fl-wrap", {'no-padding': props.noPadding})}>
                {props.children}
            </div>
        </div>
    )
}
